import { render, staticRenderFns } from "./QuestionBankCohortForm.vue?vue&type=template&id=39afa5ff&scoped=true&"
import script from "./QuestionBankCohortForm.vue?vue&type=script&lang=js&"
export * from "./QuestionBankCohortForm.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBankCohortForm.vue?vue&type=style&index=0&id=39afa5ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39afa5ff",
  null
  
)

export default component.exports